import React from 'react'

const state = {
}

const SelectionContext = React.createContext(state)

export default SelectionContext
